import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M8 4v2l2.667-2.667L8 .667v2C5.053 2.667 2.667 5.053 2.667 8c0 1.047.306 2.02.826 2.84l.974-.973C4.167 9.313 4 8.673 4 8c0-2.207 1.793-4 4-4zm4.507 1.16l-.974.973C11.827 6.693 12 7.327 12 8c0 2.207-1.793 4-4 4v-2l-2.667 2.667L8 15.333v-2c2.947 0 5.333-2.386 5.333-5.333 0-1.047-.306-2.02-.826-2.84z"
	})
});
export default SvgIconRefresh;
